import { render, staticRenderFns } from "./ObsTransitionPanel.vue?vue&type=template&id=616090e7&scoped=true&"
import script from "./ObsTransitionPanel.vue?vue&type=script&lang=js&"
export * from "./ObsTransitionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ObsTransitionPanel.vue?vue&type=style&index=0&id=616090e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616090e7",
  null
  
)

export default component.exports